<template>
	<div class="login">
		<b-row>
			<b-col>
				<b-card class="card-login" header="Accés privée de Coralie" border-variant="info">
					<b-form-input class="input-form"
    		  type="text"
    		  v-model="id"
    		  placeholder="Entrez votre identifiant"
    		  required>
    		  </b-form-input>
    		  <b-form-input class="input-form"
    		  type="password"
    		  v-model="pwd"
    		  placeholder="Entrez votre mot de passe"
    		  required>
    		  </b-form-input class="input-form">
    		  <b-button class="custom-button-login" @click="sign">Login</b-button>
    		  <p v-if="loginError" class="error-msg">{{ loginError }}</p>
				</b-card>
			</b-col>
		</b-row>
	</div>
</template>
<script>
const randomErr = [
	'Bien tenté !',
	'Sérieusement ? lol',
	"T'as cru un peu toi !",
	'Hahaha ! pathétique !!',
	'Un email a bien été envoyé a Coralie pour lui faire part de ta tentative de piratage !',
	"Dis moi Alexandre si c'est aussi peu sécurisé mon truc pourquoi tu galère autant ?"
];
import axios from 'axios';
import * as jwt from 'jsonwebtoken';
import store from 'store';
import * as _ from 'lodash';
import UpdateService from '../services/update-operations.js';
const updateService = new UpdateService();
export default {
	name: 'adminLogin',
	data: () => ({
		id: '',
		pwd: '',
		loginError: ''
	}),
	methods: {
		sign() {
			if (!this.pwd) {
				return (this.loginError = randomErr[_.random(5)]);
			}
			let token = jwt.sign({ role: this.id }, this.pwd);
			updateService
				.signToken(token)
				.then(res => {
					store.set('token', { token: `Bearer ${token}` });
					this.$parent.isLogged = true;
					this.$router.push('admin');
				})
				.catch(err => {
					this.loginError = randomErr[_.random(5)];
				});
		}
	}
};
</script>
<style lang="scss">
.input-form {
	max-width: 50%;
	text-align: center;
	margin: auto;
	margin-top: 20px;
}
.error-msg {
	font-size: 260%;
	padding-top: 1%;
}
.login {
	margin-top: 40px;
}
.card-login {
	max-width: 40%;
	margin: auto;
	border-color: #ac5e13 !important;
}
.custom-button-login {
	color: #ac5e13 !important;
	background-color: #fff !important;
	margin: 1%;
}
.custom-button-login:hover {
	color: #fff !important;
	background-color: #ac5e13 !important;
}
</style>
